<div
  class="modal fade"
  bsModal
  #paso_a_paso="bs-modal"
  [config]="{ backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title pull-left text-primary">
          {{
            firstTime
              ? ("ayuda.tutorial.titulo" | translate)
              : ("ayuda.tutorial.nombre" | translate)
          }}
        </h5>
        <button
          (click)="paso_a_paso.hide()"
          class="close pull-right"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div
            class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
            [innerHTML]="msgs"
          ></div>
          <div
            class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top {{
              firstTime ? 'margin-bottom' : ''
            }}"
          >
            <p-accordion
              (onOpen)="controlVideo($event, true)"
              (onClose)="controlVideo($event, false)"
            >
              <ng-container *ngFor="let item of pasos; let i = index">
                <p-accordionTab>
                  <ng-template pTemplate="header">
                    <span [innerHTML]="item.title"></span>
                  </ng-template>
                  <video controls loop id="{{ i }}">
                    <source [src]="item.src | safe" type="video/mp4" />
                    {{ "ayuda.tutorial.soporte_video" | translate }}
                  </video>
                  <div
                    class="margin-top text-justify"
                    [innerHTML]="item.texto"
                  ></div>
                </p-accordionTab>
              </ng-container>
            </p-accordion>
          </div>

          <div
            class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top"
            *ngIf="firstTime"
          >
            <div class="p-field-checkbox text-center">
              <p-checkbox
                [(ngModel)]="noMore"
                binary="true"
                inputId="binary"
              ></p-checkbox>
              <label class="no-margin-bottom" for="binary">{{
                "ayuda.tutorial.checkbox" | translate
              }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <p-button
          styleClass="p-button-sm"
          pRipple
          label="{{ 'button.cerrar' | translate }}"
          (click)="close()"
          icon="pi pi-times"
        ></p-button>
      </div>
    </div>
  </div>
</div>
